module.exports = __webpack_public_path__ + "static/reto-f1de6af330063ba4e97bd9414135451e.png";